import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import { getIndexerValueForMailboxInfo } from 'owa-client-types';

const DEFAULT_TOPICS_STRING = `{
  "userDefinedTopics":
  [
    {
        "title": "Newsletter",
        "description": "All emails related to newsletters or project status"
    },
    {
        "title": "Automated Alerts",
        "description": "All emails related to the automated alerts. For example, ADO notifications, access requests, etc."
    }
  ],
  "systemGeneratedTopics": []
}`;

export function getCopilotTopics(mailboxInfo: MailboxInfo): string {
    const key = getIndexerValueForMailboxInfo(mailboxInfo);
    const topics = getStore().copilotTopicsPreferencesMap.get(key)?.userDefinedTopics;
    if (!topics) {
        return DEFAULT_TOPICS_STRING;
    }

    return topics;
}
